module.exports = __webpack_public_path__ + "img/dreamweavers-5.4e469f0a.webp";